import React, { useContext, useState } from "react";
import styled from "styled-components";
import { ProductContext } from "./product-context";
import Img from 'gatsby-image'

const Container = styled.div`
  height: ${props => (props.hero ? `auto` : `${props.theme.heights[1]}px`)};
  position: relative;

  @media only screen and (min-width: ${props => props.theme.breakpoints[1]}px) {
    height: auto;
    margin-bottom: ${props => props.theme.space[3]}px;
  }
`;

const Slider = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
  background: transparent;
  top: ${props =>
    props.hero ? 0 : props.top * props.theme.heights[1] * -1.5
     - 4}px;
  transition: top 0.5s ease;
  padding: 5px;
  box-sizing: border-box;

  &:before {
    content: "";
    position: absolute;
    background: white;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: ${props => (props.visible && !props.hero ? `1` : `0`)};
    box-shadow: ${props =>
      props.visible && !props.hero ? props.theme.shadows[1] : `none`};
    border-radius: ${props => props.theme.radii[2]}px;
    transition: opacity .5s ease;
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints[1]}px) {
    position: static;
    padding: 0;
  }
`;

const RadioBoxLabel = styled.label`
  padding: 2px ${props => props.theme.space[2]}px 2px;
  height: ${props => props.hero ? props.theme.heights[1] : props.theme.heights[1] * 1.5}px;
  display: flex;
  align-items: center;
  width: 100%;
  box-shadow: ${props => (props.selected ? props.theme.shadows[1] : "none")};
  border-radius: ${props => props.theme.radii[2]}px;
  position: relative;
  box-sizing: border-box;
  opacity: ${props =>
    props.visible || props.selected || props.hero ? `1` : `0`};
  pointer-events: ${props =>
    props.visible || props.selected || props.hero ? `auto` : `none`};
  transition: box-shadow 0.5s ease;

  @media only screen and (min-width: ${props => props.theme.breakpoints[1]}px) {
    opacity: 1;
    pointer-events: auto;
  }

  &:before {
    content: "";
    display: none;
    position: absolute;
    top: ${props => props.theme.space[2]}px;
    left: ${props => props.theme.space[2]}px;
    width: 0.9em;
    height: 0.9em;
    border-radius: 50%;
    background: ${props =>
      props.selected ? props.theme.colors.rojoBac : props.theme.colors.blanco};
    border: 1px solid
      ${props =>
        props.selected
          ? props.theme.colors.blanco
          : props.theme.colors.grisClaro};
    transition: background 0.5s ease, border 0.5s ease;
  }
`;

const IconContainer = styled.div`
  display: ${props => (props.hero ? `none` : `block`)};
  position: absolute;
  top: 18px;
  right: 12px;

  @media only screen and (min-width: ${props => props.theme.breakpoints[1]}px) {
    display: none;
  }
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 6px 5px;
  border-color: transparent transparent ${props => props.theme.colors.amexBlue} transparent;
  ${props => props.down && `transform: rotate(180deg);`}
  margin-bottom: 3px;
`;

export default ({ variaciones, id }) => {
  const { selectedColorKey, setSelectedColorKey } = useContext(ProductContext);
  const [visible, setVisible] = useState(false);
  const isHero = id === "hero";

  function handleChangr(index) {
    setSelectedColorKey(index);
    setVisible(false);
  }

  function handleClick(v) {
    if (v) {
      return null
    } else {
      setVisible(true);
    }
  };

  return (
    <Container top={selectedColorKey} hero={isHero}>
      <Slider top={selectedColorKey} hero={isHero} visible={visible}>
        {variaciones.map((variacion, index) => (
          <div key={variacion.id}>
            <RadioBoxLabel
              selected={index === selectedColorKey}
              visible={visible}
              hero={isHero}
              onClick={() => handleClick(visible)}
            >
              <input
                style={{ display: `none` }}
                type="radio"
                value={index}
                id={`color-switch-${variacion.id}`}
                name={`color-switch-${variacion.id}`}
                onChange={() => handleChangr(index)}
                checked={index === selectedColorKey}
              />

              {!isHero && (
                <div style={{ width: `50px`, marginRight: `8px` }}>
                  <Img fluid={variacion.arte.fluid} alt={variacion.titulo} />
                </div>
              )}

              {variacion.color.titulo}
            </RadioBoxLabel>
          </div>
        ))}
      </Slider>
      <IconContainer hero={isHero}>
        <Triangle />
        <Triangle down />
      </IconContainer>
    </Container>
  );
};
